import dayjs from "dayjs"
import { saveAs } from "file-saver" // path to file-saver
import { renderDateTime } from "./helper"

// Download file
export function base64toBlob(base64Data, contentType) {
  contentType = contentType || ""
  const sliceSize = 1024
  const byteCharacters = atob(base64Data)
  const bytesLength = byteCharacters.length
  const slicesCount = Math.ceil(bytesLength / sliceSize)
  const byteArrays = new Array(slicesCount)
  for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
    const begin = sliceIndex * sliceSize
    const end = Math.min(begin + sliceSize, bytesLength)

    const bytes = new Array(end - begin)
    for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
      bytes[i] = byteCharacters[offset].charCodeAt(0)
    }
    byteArrays[sliceIndex] = new Uint8Array(bytes)
  }
  return new Blob(byteArrays, { type: contentType })
}

export function FileToBase64(file: File) {
  const reader: FileReader = new FileReader()
  return new Promise((resolve: any, reject: any) => {
    reader.onerror = () => {
      reader.abort()
      reject(new Error("Error parsing file"))
    }
    reader.readAsBinaryString(file)
    reader.onloadend = () => {
      const base64StringFile = btoa(reader.result as string) // eslint-disable-line no-undef
      resolve({
        base64StringFile,
        fileName: file.name,
        mimeType: file.type,
      })
    }
    // reader.readAsArrayBuffer(file);
  })
}

export function downloadFileDetectExtension(data, fileName?) {
  // Detect file extension từ MIME type
  console.log("data", data)
  const getExtensionFromMimeType = (mimeType) => {
    const mimeTypeMap = {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        "xlsx",
      "application/vnd.ms-excel": "xls",
      "application/pdf": "pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        "docx",
      "application/msword": "doc",
      "text/csv": "csv",
      "application/zip": "zip",
      "application/json": "json",
    }
    return mimeTypeMap[mimeType] || "file"
  }

  // Tạo tên file mặc định với timestamp
  const timestamp = renderDateTime(dayjs())
  const extension = getExtensionFromMimeType(data.type)
  const defaultFileName = `${fileName || "export"}_${timestamp}.${extension}`

  // Tạo URL blob từ data
  const url = window.URL.createObjectURL(data)
  const a = document.createElement("a")
  document.body.appendChild(a)
  a.setAttribute("style", "display: none")
  a.href = url
  a.download = defaultFileName
  a.click()
  window.URL.revokeObjectURL(url)
  a.remove()
}

export function downloadFile(data, fileName) {
  const url = window.URL.createObjectURL(data)
  const a = document.createElement("a")
  document.body.appendChild(a)
  a.setAttribute("style", "display: none")
  a.href = url
  a.download = fileName
  a.click()
  window.URL.revokeObjectURL(url)

  a.remove() // remove the element
}
export function downloadDocument(data, contentDispositionHeader?) {
  // Xử lý dữ liệu từ API
  if (!data) {
    console.error("No data provided for download")
    return
  }
  let blob
  let fileName = "document"

  // Ưu tiên lấy fileName từ contentDispositionHeader được truyền vào
  if (contentDispositionHeader) {
    const fileNameMatch = contentDispositionHeader.match(
      /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
    )
    if (fileNameMatch && fileNameMatch[1]) {
      fileName = fileNameMatch[1].replace(/['"]/g, "")
    }
  }

  // Kiểm tra nếu data có structure từ API response
  if (data.fileName && data.base64Data) {
    // Trường hợp API trả về base64 data
    const contentType = data.mimeType || data.contentType || ""
    blob = base64toBlob(data.base64Data, contentType)
    if (!contentDispositionHeader) {
      fileName = data.fileName
    }
  } else if (data.fileName && data.fileContent) {
    // Trường hợp API trả về binary data
    blob = new Blob([data.fileContent], {
      type: data.mimeType || data.contentType || "application/octet-stream",
    })
    if (!contentDispositionHeader) {
      fileName = data.fileName
    }
  } else if (data instanceof Blob) {
    // Trường hợp data đã là Blob
    blob = data
    // Nếu không có contentDispositionHeader, sử dụng tên mặc định
    if (!contentDispositionHeader) {
      fileName = "document"
    }
  } else if (data.data && data.headers) {
    // Trường hợp response có headers (từ axios)
    blob = new Blob([data.data], {
      type: data.headers["content-type"] || "application/octet-stream",
    })

    // Nếu chưa có fileName từ contentDispositionHeader, thử lấy từ response headers
    if (!contentDispositionHeader && fileName === "document") {
      const contentDisposition = data.headers["content-disposition"]
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        )
        if (fileNameMatch && fileNameMatch[1]) {
          fileName = fileNameMatch[1].replace(/['"]/g, "")
        }
      }
    }

    // Nếu vẫn không có filename, thử lấy từ URL params hoặc config
    if (fileName === "document" && data.config?.params?.key) {
      // Lấy tên file từ key parameter nếu có
      const keyParam = data.config.params.key
      const fileNameFromKey = keyParam.split("/").pop() // Lấy phần cuối cùng sau dấu /
      if (fileNameFromKey && fileNameFromKey.includes(".")) {
        fileName = fileNameFromKey
      }
    }
  } else {
    // Fallback: treat as raw data
    blob = new Blob([data], { type: "application/octet-stream" })
  }

  // Download file
  downloadFile(blob, fileName)
}

export const downloadExcel = (data, fileName) => {
  const blob = new Blob([data], {
    type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  })
  saveAs(blob, `${fileName}.xlsx`)
}

export function downloadFromStream(blobContent, fileName) {
  const blob = new Blob([blobContent], { type: "application/octet-stream" })
  saveAs(blob, fileName)
}
